import { Heading, HeadingProps } from '@chakra-ui/react';

export const H1: React.FC<HeadingProps> = (props): JSX.Element => {
  const { children, ...rest } = props;

  return (
    <Heading as="h1" {...rest}>
      {children}
    </Heading>
  );
};

H1.defaultProps = {
  fontSize: '3xl',
  fontWeight: 'bold',
  mb: 4,
};
